module.exports = __webpack_public_path__ + "img/party.93568d97.svg";